import * as React from 'react';
import { observable } from 'mobx';

class ModalLoader {

  @observable listeners:Array<any> = [];
  @observable title:string;
  @observable content:string|null;
  @observable showModal = false;

  open = (title, content) => {
    this.title = title;
    this.content = content;
    this.showModal = true;
  }

  close = () => {
    this.showModal = false;
    setTimeout(()=>{
      this.title = '';
      this.content = null;
    }, 250);
  }

}

const modalLoader = new ModalLoader();
export { modalLoader };

